import camelcaseKeys from 'camelcase-keys';

import { baseApi } from 'api/api-base';
import { API_ROUTES } from 'constants/api-routes';
import { ClickAnnouncement, GetActiveAnnouncements } from 'types/api/api-announcements.types';

// Operator announcements (pop-ups): the active feed for the logged-in customer's org, plus the
// click counter. Impressions are counted server-side by the active fetch itself.
export const announcementsApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getActiveAnnouncements: builder.query<GetActiveAnnouncements.ResponseType, GetActiveAnnouncements.RequestType>({
      query: () => ({
        url: API_ROUTES.GET_ACTIVE_ANNOUNCEMENTS,
      }),
      extraOptions: {},
      transformResponse: (response: GetActiveAnnouncements.RawApiResponse): GetActiveAnnouncements.ResponseType =>
        camelcaseKeys(response as unknown as Record<string, unknown>, {
          deep: true,
        }) as unknown as GetActiveAnnouncements.ResponseType,
    }),
    clickAnnouncement: builder.mutation<ClickAnnouncement.ResponseType, ClickAnnouncement.RequestType>({
      query: id => ({
        url: `${API_ROUTES.ANNOUNCEMENTS}/${id}/click`,
        method: 'POST',
      }),
      extraOptions: {},
    }),
  }),
});

export const { useGetActiveAnnouncementsQuery, useClickAnnouncementMutation } = announcementsApi;
